module.exports = __webpack_public_path__ + "static/media/WsC43.c2c28963.PNG";